module.exports = __webpack_public_path__ + "static/media/report_position.098459c1.svg";